<template>
  <div>
    <v-card-title class="pa-0">{{ $t("columnSelection") }}</v-card-title>

    <v-card-text class="pa-0">
      <div class="column-scroll">
        <v-col class="pa-0 ma-0" max-width="10000" v-for="column in headers" :key="'cb' + column">
          <v-checkbox dense :input-value="isChecked(column)" :label="$t(column)" @change="updateChecked(column)" hide-details />
        </v-col>
      </div>
    </v-card-text>
  </div>
</template>

<script>
export default {
  name: "ColumnControl",
  data: () => ({
    selectedColumns: []
  }),
  props: {
    title: String,
    headers: Array,
    columnSelection: Array
  },
  mounted() {
    this.selectedColumns = this.columnSelection;
  },
  methods: {
    updateChecked(column) {
      const index = this.selectedColumns.findIndex((c) => c === column);
      if (index === -1) this.selectedColumns.push(column);
      else this.selectedColumns.splice(index, 1);
      this.$emit("update", this.selectedColumns);
    },
    isChecked(column) {
      return this.selectedColumns.find((c) => c === column) !== undefined;
    }
  }
};
</script>

<style scoped>
.column-scroll {
  max-height: 50vh;
  overflow-y: auto;
  padding-right: 8px;
}
</style>
